import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAdminContext } from "../adminstore/Admin-Context";
import EditWarning from "../header/EditWarning";
import { AccountInfoActive, AccountInfoNormal, AccountSettingsActive, AccountSettingsNormal, APIActive, APILogsActive, APILogsNormal, APINormal, AutoAttendantsActive, AutoAttendantsNormal, BillingAccountInfoActive, BillingAccountInfoNormal, BillingGroupsAndAdminsActive, BillingGroupsAndAdminsNormal, CallFlowsActive, CallFlowsNormal, ContactActive, ContactNormal, DialbyDirectoryActive, DialbyDirectoryNormal, FAXGroupsActive, FAXGroupsNormal, GlobalSettingsActive, GlobalSettingsNormal, HuntGroupsActive, HuntGroupsNormal, IPPhoneAndDevicesActive, IPPhoneAndDevicesNormal, LocationActive, LocationNormal, LunaAiActive, LunaAiNormal, MediaLibraryActive, MediaLibraryNormal, OrgGroupsActive, OrgGroupsAndPoolsActive, OrgGroupsAndPoolsNormal, OrgGroupsNormal, PermissionRolesActive, PermissionRolesNormal, PhoneNumbersActive, PhoneNumbersNormal, ReportsActive, ReportsNormal, SecurityActive, SecurityManagerActive, SecurityManagerNormal, SecurityNormal, SharedVmActive, SharedVmNormal, SLAKPIActive, SLAKPINormal, SMSActive, SMSNormal, SpamAndBlockingActive, SpamAndBlockingNormal, SSOActive, SSONormal, StarsIcon, StreamsSettingsActive, StreamsSettingsNormal, StreamsTeamsActive, StreamsTeamsNormal, TelephoneIcon, UsersActive, UsersNormal } from "../images";
import UIConstant from "../../apiclients/UIConstant";
import { show_links_tab } from "../../../src/apiclients/apiurls"
import { isFiveNineAccount } from "../../views/Login";
import { getStreamsProductName } from "../../apiclients/CommonUtils";

function SubLinks(props) {
  const { t, i18n } = useTranslation();
  const { isEdited, setEdited } = useAdminContext();
  const [showWarning, setShowWarning] = useState(false);
  const [targetView, setTargetView] = useState('');
  const warningToggle = () => setShowWarning(!showWarning);
  const streamsProductName = getStreamsProductName();
  const isAdminSession = JSON.parse(sessionStorage.getItem("admin_session"));
  const allowUserPermissionRole = isAdminSession?.permissions
    ? (isAdminSession?.permissions.includes(UIConstant.ALLOW_ADD_DELETE_EDIT_PERMISSION_ROLES))
    : true;

  const allowAccountSettings = isAdminSession?.permissions
    ? (isAdminSession?.permissions.includes(UIConstant.ALLOW_ADD_DELETE_EDIT_ACCOUNT_SETTINGS))
    : true;
  const isFiveNineAcc = isFiveNineAccount();
  const handleOk = () => {
    setEdited(false);
    window.location.href = targetView;
    setShowWarning(false);
  };
  const isAccountLogin = (JSON.parse(sessionStorage.getItem("admin_session"))?.isAccountAdmin === true) ?? false;
  const isSuperAdmin = (JSON.parse(sessionStorage.getItem("admin_session"))?.isSuperAdmin === true) ?? false;
  const showReputation = (JSON.parse(sessionStorage.getItem("admin_session"))?.showReputation === true) ?? false;
  const showSMSCampaigns = (JSON.parse(sessionStorage.getItem("admin_session"))?.showSMSCampaigns === true) ?? false;
  const siteId = JSON.parse(sessionStorage.getItem("admin_session"))?.siteid;
  const accountName = JSON.parse(sessionStorage.getItem("admin_session"))?.logined_user;
  const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;

  const displayWarning = <div>{showWarning && (
    <EditWarning
      warningToggle={warningToggle}
      setShowWarning={setShowWarning}
      onOk={handleOk}
    />
  )
  }
  </div>



  function goTo(e, tview, tabid) {
    if (isEdited) {
      setTargetView(tview);
      setShowWarning(true);
      return;

    }
    sessionStorage.setItem("mainTabId", tabid);
    window.location.href = tview;
  }
  const [hideSubmenu, setHideSubmenu] = useState(props.hideSubmenu);

  useEffect(() => {
    setHideSubmenu(props.hideSubmenu);
  }, [props.hideSubmenu]);
  const [subLinks, setSubLinks] = useState([
    {
      id: "1",
      links: [
        {
          tabid: "",
          tempid: "",
          label: "Account Info",
          view: "accinfo",
          icon: "home"
        },
      ],
    },
    {
      id: "2",
      links: [
        {
          tabid: "36",
          tempid: 54,
          label: "Phone Numbers",
          view: "phonenumbers",
          icon: PhoneNumbersNormal,
          activeIcon: PhoneNumbersActive,
        },
        // ...(showReputation ? [
        // {
        //   tabid: "37",
        //   label: "Reputation",
        //   view: "reputationlanding",
        //   icon: PhoneNumbersNormal,
        //   activeIcon: PhoneNumbersActive,
        // }
        // ] : []),
        ...(!isFiveNineAcc ? [
          {
            tabid: "41",
            tempid: 55,
            label: "Call Flows",
            view: "callflowlanding",
            icon: CallFlowsNormal,
            activeIcon: CallFlowsActive,
          },
          {
            tabid: "42",
            tempid: 56,
            label: "Luna AI",
            view: "luna-landing",
            icon: LunaAiNormal,
            activeIcon: LunaAiActive,
          },
          {
            tabid: "9",
            tempid: 57,
            label: "Spam & Blocking",
            view: "spamblocking",
            icon: SpamAndBlockingNormal,
            activeIcon: SpamAndBlockingActive,
          },
          {
            tabid: "18",
            tempid: 58,
            label: "Auto-Attendants",
            view: "autoattendant",
            icon: AutoAttendantsNormal,
            activeIcon: AutoAttendantsActive
          },
          {
            tabid: "19",
            tempid: 59,
            label: "Hunt Groups",
            view: "huntgroup",
            icon: HuntGroupsNormal,
            activeIcon: HuntGroupsActive,
          },
          // {
          //   tabid: "89",
          //   label: "ACD Queues",
          //   view: "acdQueues",
          //   icon: "users_landing",
          // },
          {
            tabid: "281",
            tempid: 60,
            label: "Fax Groups",
            view: "faxgroupslandingpage ",
            icon: FAXGroupsNormal,
            activeIcon: FAXGroupsActive,
          },
          {
            tabid: "10",
            tempid: 61,
            label: "Devices",
            view: "pslanding",
            icon: IPPhoneAndDevicesNormal,
            activeIcon: IPPhoneAndDevicesActive,
          },
          {
            tabid: "29",
            tempid: 62,
            label: "Media Library",
            view: "medialanding",
            icon: MediaLibraryNormal,
            activeIcon: MediaLibraryActive,
          },
          // ...(show_links_tab == 1 ? [
            {
              tabid: "129",
              label: "Shared VM",
              view: "vmlanding",
              icon: SharedVmNormal,
              activeIcon: SharedVmActive,
            }
          // ] : [])
            ,

          {
            tabid: "31",
            tempid: 63,
            label: "Dial by Name Directories",
            view: "dialbydirectoriesLanding",
            icon: DialbyDirectoryNormal,
            activeIcon: DialbyDirectoryActive,
          }
        ] : []),
        {
          tabid: "32",
          tempid: 64,
          label: "Global Settings",
          view: "globalsettings",
          icon: GlobalSettingsNormal,
          activeIcon: GlobalSettingsActive,
        },
        // {/* Added the  SMS Registration and smsgroups Link in PhoneSystem from AdminTools according to Jerome's Enhancements suggested changes */}
        ...(isAccountLogin == true || isSuperAdmin == true ? [
          {
            tabid: "270",
            tempid: 161,
            label: "SMS Registration",
            view: "smslanding",
            icon: SMSNormal,
            activeIcon: SMSActive,
          }
        ] : []),
        ...(!isFiveNineAcc ? [
          {
            tabid: "283",
            tempid: 65,
            label: t("smsgroups"),
            view: "smsgroupslanding",
            icon: OrgGroupsAndPoolsNormal,
            activeIcon: OrgGroupsAndPoolsActive,
          },
        ] : [])
      ],
    },
    {
      id: "3",
      links: [
        {
          tabid: "8",
          tempid: 33,
          label: "Users",
          view: "userlanding",
          icon: UsersNormal,
          activeIcon: UsersActive,
        },
        ...(!isFiveNineAcc ? [
          {
            tabid: "15",
            tempid: 34,
            label: `${streamsProductName} Teams`,
            view: "streamsteamssection",
            icon: StreamsTeamsNormal,
            activeIcon: StreamsTeamsActive,
          }
        ] : []),

        ...((allowUserPermissionRole && !isFiveNineAcc) ?
          [{
            tabid: "53",
            tempid: 35,
            label: "Permission Roles",
            view: "permissionrolessection",
            icon: PermissionRolesNormal,
            activeIcon: PermissionRolesActive,
          },{
            tabid: "350",
            tempid: 350,
            label: "Device Manager",
            view: "streamsmanager",
            icon: IPPhoneAndDevicesNormal,
            activeIcon: IPPhoneAndDevicesActive,
          }
        ] : []),

      ],
    },

    {
      id: "4",
      links: [
        {
          tabid: "267",
          label: "Reports",
          view: "reports",
          icon: ReportsNormal,
          activeIcon: ReportsActive,
        },
        {
          tabid: "293",
          label: "SLA/KPI",
          view: "accinfo",
          icon: SLAKPINormal,
          activeIcon: SLAKPIActive,
        },
        {
          tabid: "295",
          label: "API Logs",
          view: "apilogs",
          icon: APILogsNormal,
          activeIcon: APILogsActive,
        },
        {
          tabid: "249",
          label: "Sentiment Analysis",
          view: "sentiments",
          icon: "home",
        },

      ],
    },
    {
      id: "5",
      links: [
        {
          tabid: "284",
          tempid: 140,
          label: "Overview",
          view: "usageSummary",
          icon: BillingGroupsAndAdminsNormal,
          activeIcon: BillingGroupsAndAdminsActive,
        },
        {
          tabid: "297",
          tempid: 141,
          label: "Billing Groups",
          view: "billinglanding",
          icon: BillingGroupsAndAdminsNormal,
          activeIcon: BillingGroupsAndAdminsActive,
        },
        {
          tabid: "222",
          tempid: 142,
          label: "Billing Account Info",
          view: "billingaccountinfo",
          icon: "location",
          icon: BillingAccountInfoNormal,
          activeIcon: BillingAccountInfoActive,
        },

        // {
        //   tabid: "227",
        //   label: "Organizations",
        //   view: "accinfo",
        //   icon: "home"
        // },
        // {
        //   tabid: "225",
        //   label: "Org Pools",
        //   view: "orgpools",
        //   icon: "location",
        // },
        // {
        //   tabid: "189",
        //   label: "Manage Groups Superadmins",
        //   view: "managegrpadmins",
        //   icon: "location",
        // },
        // {
        //   tabid: "299",
        //   label: "Invoices",
        //   view: "invoices",
        //   icon: "location",
        // },
      ],
    },
    {
      id: "6",
      links: [
        {
          tabid: "123",
          tempid: 119,
          label: "Account Information",
          view: "accountinfolanding",
          icon: AccountInfoNormal,
          activeIcon: AccountInfoActive,
        },
        ...(allowAccountSettings ? [
          {
            tabid: "128",
            tempid: 120,
            label: "Account Settings",
            view: "accountsettings",
            icon: AccountSettingsNormal,
            activeIcon: AccountSettingsActive,
          }] : []),
        // Hide the Link according to Jerome's Enhancements suggested changes
        ...(isAccountLogin == true|| isSuperAdmin == true ? [{
          tabid: "4",
          tempid: 157,
          label: "APIs",
          view: "apilanding",
          icon: APINormal,
          activeIcon: APIActive,
        }] : []),
        {
          tabid: "275",
          tempid: 121,
          label: "Contacts",
          view: "contactslanding",
          icon: ContactNormal,
          activeIcon: ContactActive,
        },
        {
          tabid: "282",
          tempid: 122,
          label: "Org Groups",
          view: "orggroupslandingpage ",
          icon: OrgGroupsNormal,
          activeIcon: OrgGroupsActive,
        },
        //  Hide the Link according to Jerome's Enhancements suggested changes

        // ...(show_links_tab === 1 ? [
        //   {
        //     tabid: "270",
        //     label: "SMS",
        //     view: "smslanding",
        //     icon: SMSNormal,
        //     activeIcon: SMSActive,
        //   }] : []),
        // {
        //   tabid: "283",
        //   label: t("smsgroups"),
        //   view: "smsgroupslanding",
        //   icon: OrgGroupsAndPoolsNormal,
        //   activeIcon: OrgGroupsAndPoolsActive,
        // },
        {
          tabid: "269",
          tempid: 123,
          label: `${streamsProductName} Settings`,
          view: "streamssettings",
          icon: StreamsSettingsNormal,
          activeIcon: StreamsSettingsActive,
        },
 
        ...((isAccountLogin == true || isSuperAdmin == true) && !isWholesaleAcc
          ? [
            {
              tabid: "272",
              label: "Microsoft Integrations",
              view: "msentraidlanding",
              icon: SSONormal,
              activeIcon: SSOActive,
            },
          ]
          : []
        ),
        {
          tabid: "271",
          tempid: 124,
          label: "Security",
          view: "Securitylanding",
          icon: SecurityNormal,
          activeIcon: SecurityActive,
        },
        // {
        //   tabid: "130",
        //   label: "Security Manager",
        //   view: "securityregistrationlanding",
        //   icon: SecurityManagerNormal,
        //   activeIcon: SecurityManagerActive,
        // },
        // {
        //   tabid: "272",
        //   label: "Microsoft Entra ID",
        //   view: "msentraidlanding",
        //   icon: SSONormal,
        //   activeIcon: SSOActive,
        // },

        // {
        //   tabid: "255",
        //   // label: "Streams App",
        //   label: "Security Manager",
        //   view: "securityregistrationlanding",
        //   icon: "home"
        // },
        // {
        //   tabid: "40",
        //   // label: "Site Survey",
        //   label: "Storage Manager",
        //   view: "accinfo",
        //   icon: "home"
        // },
        // {
        //   tabid: "112",
        //   // label: "Security Registration",
        //   label: "Multi Login Settings",
        //   view: "secregs",
        //   icon: "location",
        // },
        // {
        //   tabid: "113",
        //   label: "UCC Settings",
        //   view: "UCCSettings",
        //   icon: "location",
        // },
        // {
        //   tabid: "114",
        //   label: "SmartBox Settings",
        //   icon: "location",
        // },
        // {
        //   tabid: "115",
        //   label: "Single Sign-On",
        //   icon: "location",
        // },
        // {
        //   tabid: "116",
        //   label: "Streams Notifications",
        //   icon: "location",
        // },
        // {
        //   tabid: "117",
        //   label: "Public Teams",
        //   icon: "location",
        // },
        // {
        //   tabid: "118",
        //   label: "Streams Settings",
        //   icon: "location",
        // },
        // {
        //   tabid: "119",
        //   label: "Active Directory Integration",
        //   icon: "location",
        // },
        // {
        //   tabid: "120",
        //   label: "MFA for every Login",
        //   icon: "location",
        // },
      ],
    },
    {
      id: "7",
      links: [
        {
          tabid: "7",
          tempid: 8,
          label: "Locations",
          view: "loclanding",
          icon: LocationNormal,
          activeIcon: LocationActive,
        },
      ],
    },
  ]);



  const [themeBasedLogo, setThemeBasedLogo] = useState(localStorage.getItem("selectedColorTheme"))
  console.log(themeBasedLogo, "themeBasedLogo")
  useEffect(() => {
    if (themeBasedLogo === "system") {
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      if (systemPrefersDark) {
        setThemeBasedLogo("dark")
      }
      else {
        setThemeBasedLogo(localStorage.getItem("selectedColorTheme"));
      }
      console.log(systemPrefersDark, "systemPrefersDark")
    }
  }, [themeBasedLogo])


  return (
    <>
      <nav
        className={
          hideSubmenu
            ? "sidenav d-lg-block border-1 toggled"
            : "sidenav d-lg-block border-1 "
        }
        id="sidenav-2"
        data-mdb-mode="side"
        data-mdb-content="#content"
      >
        <ul className="sidenav-menu list-group list-group-flush ml-2 submenu">
          <li className="sidenav-item">
            {subLinks.length > 0 &&
              subLinks.map((linkObj, index) => (
                <>

                  {linkObj.id * 1 == props.tablinkid * 1 &&
                    linkObj.links.map((link) => (
                      <div
                        className="sidenav-link list-group-item list-group-item-action ripple"
                        aria-current="true"
                        id={props.slinkid == link.tabid ? "active-own" : ""}
                        onClick={(e) => goTo(e, link.view, link.tempid)}
                      >
                        <img
                          src={props.slinkid == link.tabid ? link.activeIcon : link.icon}
                          alt=""
                          style={{ width: "25px" }}
                          className={`me-3 ${props.slinkid == link.tabid || themeBasedLogo == "dark" ? "" : ""}`}
                        />
                        <span>{link.label}</span>
                        {/* {link.label === "Luna AI" && <>
                          <img
                            src={StarsIcon}
                            alt=""
                            className={`ms-2 ${props.slinkid == link.tabid || themeBasedLogo == "dark" ? "invert" : ""}`}
                          />
                          <img
                            src={TelephoneIcon}
                            alt=""
                            className={`ms-2 ${props.slinkid == link.tabid || themeBasedLogo == "dark" ? "invert" : ""}`}
                          />

                        </>} */}
                      </div>
                    ))}
                </>
              ))}
          </li>
        </ul>
      </nav>
      {displayWarning}
    </>
  );
}
export default SubLinks;
